import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NavParams } from 'ionic-angular';
import { TournamentService } from '../../../../services/tournament.service';

@Component({
  selector: 'ko-overview',
  templateUrl: 'ko-overview.html',
})
export class KoOverviewPage {
  gamePlanList: IGamePlan[] = [];
  
  @Input() activePlan: any;
  @Input() header: boolean = true;

  @Output() onEdit = new EventEmitter<any>();

  constructor(public gs: TournamentService){}

  onEditTeam(i: number, j: number){
    this.onEdit.emit({ i: i, j: j});
  }

  onRemoveTeam(){

  }
}

export interface IGamePlan {
  id: number;
  gameDay: number;
  name: string;
  team1: {
    id: number;
    name: string;
  };
  team2: {
    id: number;
    name: string;
  }
}






// WEBPACK FOOTER //
// /src/pages/apps/gamer/pages/results/result-ko/overview/ko-overview.ts